import request from "@/router/axios"
export const list = () => {
    return request({
        url: `/api/op/project/list`,
        method: 'post',
        data: {
            orderBy: "id",
            isDesc: false
        }
    })
}
export const projectParts = (projectId) => {
    return request({
        url: `/api/op/part/list`,
        method: 'post',
        data: {
            filterParams: [{ name: "projectId", value: projectId }],
            orderBy: "id",
            isDesc: false
        }
    })
}
export const listByHos = (hosId) => {
    return request({
        url: `/api/op/project/list`,
        method: 'post',
        data: {
            filterParams: [{ name: "hosId", value: hosId }],
            orderBy: "id",
            isDesc: false
        }
    })
}
export const getHosProjects = (hosId) => {
    return request({
        url: `/api/op/project/list`,
        method: 'post',
        data: {
            filterParams: [{ name: "hosId", value: hosId }],
            orderBy: "id",
            isDesc: false
        }
    })
}
export const editProject = (data) => {
    return request({
        url: `/api/op/project/edit`,
        method: 'post',
        data: data
    })
}
export const editPart = (data) => {
    return request({
        url: `/api/op/part/edit`,
        method: 'post',
        data: data
    })
}
